import React from 'react';

const CopyIcon2 = ({ className = '' }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 2.60713H0.5C0.367392 2.60713 0.240215 2.65981 0.146447 2.75358C0.0526785 2.84735 0 2.97452 0 3.10713V12.1071C0 12.2397 0.0526785 12.3669 0.146447 12.4607C0.240215 12.5545 0.367392 12.6071 0.5 12.6071H9.5C9.63261 12.6071 9.75979 12.5545 9.85355 12.4607C9.94732 12.3669 10 12.2397 10 12.1071V3.10713C10 2.97452 9.94732 2.84735 9.85355 2.75358C9.75979 2.65981 9.63261 2.60713 9.5 2.60713ZM9 11.6071H1V3.60713H9V11.6071ZM12 1.10713V10.1071C12 10.2397 11.9473 10.3669 11.8536 10.4607C11.7598 10.5545 11.6326 10.6071 11.5 10.6071C11.3674 10.6071 11.2402 10.5545 11.1464 10.4607C11.0527 10.3669 11 10.2397 11 10.1071V1.60713H2.5C2.36739 1.60713 2.24021 1.55445 2.14645 1.46069C2.05268 1.36692 2 1.23974 2 1.10713C2 0.974524 2.05268 0.847347 2.14645 0.753579C2.24021 0.65981 2.36739 0.607132 2.5 0.607132H11.5C11.6326 0.607132 11.7598 0.65981 11.8536 0.753579C11.9473 0.847347 12 0.974524 12 1.10713Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyIcon2;
